import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components/Dropdown';

import ActionButton from './components/ActionButton';
import Separator from './styled';

import './style.scss';

const ImportExportDropdown = ({
  modelName,
  onExport,
  onMergeImport,
  onReplaceImport,
}) => {
  const dropdown = useRef(null);

  const handleExportClick = () => {
    onExport();
    dropdown.current.hide();
  };

  const handleImportMergeClick = () => {
    onMergeImport();
    dropdown.current.hide();
  };

  const handleImportReplaceClick = () => {
    onReplaceImport();
    dropdown.current.hide();
  };

  return (
    <Dropdown
      inputRef={dropdown}
      styleName="dropdown"
      trigger={<i className="icon-options" />}
    >
      <ActionButton
        dataTest="full-partial-export"
        iconName="icon-upload"
        label={`Export all ${modelName}`}
        onClick={handleExportClick}
      />

      <Separator />

      <ActionButton
        dataTest="partial-import-merge-button"
        iconName="icon-download"
        label="Import & Merge"
        onClick={handleImportMergeClick}
      />

      <ActionButton
        dataTest="partial-import-replace-button"
        iconName="icon-download"
        label="Import & Replace"
        onClick={handleImportReplaceClick}
      />
    </Dropdown>
  );
};

ImportExportDropdown.propTypes = {
  modelName: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
  onMergeImport: PropTypes.func.isRequired,
  onReplaceImport: PropTypes.func.isRequired,
};

export default ImportExportDropdown;
